/* @flow */
import { observable } from 'mobx';

import { ApiModel } from 'api/ApiModel';
import type { CustomerAccount, DataSource } from 'models/CustomerAccounts';

export default class CustomerAccountStore extends ApiModel {
  @observable selectedCustomerAccount: CustomerAccount | void;
  @observable selectedCustomerAccountDataSource: DataSource | void;
  @observable customerAccountLoading = false;

  loadCustomerAccount = async (
    dataSource: DataSource,
    customerAccountId: string,
    companyCode: string
  ) => {
    this.customerAccountLoading = true;
    this.selectedCustomerAccount = undefined;
    const customerAccount = await this.api.getResource(
      `customer-account-management/${dataSource}/${customerAccountId}/${companyCode}`
    );

    if (customerAccount) {
      this.selectedCustomerAccount = customerAccount;
      this.selectedCustomerAccountDataSource = dataSource;
    }

    this.customerAccountLoading = false;
    return customerAccount;
  };
}
